<template>
<md-card-content class="ql-cue-body" v-bind:style="style()" :key="handler">
    <form novalidate @submit.stop.prevent="keyPress" @keyup.stop.prevent="keyPress" v-if="localCue.data">
        <div class="flex-row">
            <md-input-container class="field-label">
                <label for="label">Label</label>
                <md-input :value="localCue.data.label" @blur="e => modifyCue('data.label', e)" :readonly="!editable"></md-input>
            </md-input-container>
            <md-button class="md-icon-button" v-if="!locked && !editing && editable" @click="destroy">
                <md-icon>delete</md-icon>
                <md-tooltip>Delete Cue</md-tooltip>
            </md-button>
        </div>
        <div class="flex-row">
            <md-input-container class="field-description" v-if="isAvailable('description')">
                <label for="description">Description</label>
                <md-input :value="localCue.data.description" @blur="e => modifyCue('data.description', e)" :readonly="!editable"></md-input>
            </md-input-container>
            <md-input-container class="field-parts" v-if="isAvailable('parts')">
                <label for="parts">Parts</label>
                <select class="custom-select" v-model="localCue.data.parts" @change="partsChanged" :disabled="!editable" style="width: 42px;">
                    <option v-for="(part, index) in ['', 2,3,4,5,6,7,8]" :value="part" :key="index">{{part}}</option>
                </select>
            </md-input-container>
        </div>
        <div class="flex-row flex-column" v-if="localCue.data.parts">
            <div class="field-parts-data flex-row flex-column" v-for="partData in localCue.data.partsData" :key="getPartIndex(partData)">
                <div class="flex-row">
                    <md-input-container class="field-part">
                        <label for="part">P</label>
                        <md-input v-model="partData.id" @blur="modifyCue(`data.partsData`, localCue.data.partsData)" :readonly="!editable"></md-input>
                    </md-input-container>
                    <md-input-container class="field-part-label" v-if="isAvailable('label')">
                        <label for="part-label">Label</label>
                        <md-input v-model="partData.label" @blur="modifyCue(`data.partsData`, localCue.data.partsData)" :readonly="!editable"></md-input>
                    </md-input-container>
                </div>
                <div class="flex-row">
                    <md-input-container class="field-time" v-if="isAvailable('time')">
                        <label for="time">Time</label>
                        <md-input v-model="partData.time" @blur="modifyCue(`data.partsData`, localCue.data.partsData)" :readonly="!editable"></md-input>
                    </md-input-container>
                    <md-input-container class="field-focus" v-if="isAvailable('focus')">
                        <label for="focus">Focus</label>
                        <md-input v-model="partData.focus" @blur="modifyCue(`data.partsData`, localCue.data.partsData)" :readonly="!editable"></md-input>
                    </md-input-container>
                    <md-input-container class="field-color" v-if="isAvailable('color')">
                        <label for="color">Color</label>
                        <md-input v-model="partData.color" @blur="modifyCue(`data.partsData`, localCue.data.partsData)" :readonly="!editable"></md-input>
                    </md-input-container>
                    <md-input-container class="field-beam" v-if="isAvailable('beam')">
                        <label for="beam">Beam</label>
                        <md-input v-model="partData.beam" @blur="modifyCue(`data.partsData`, localCue.data.partsData)" :readonly="!editable"></md-input>
                    </md-input-container>
                    <md-input-container class="field-mark" v-if="isAvailable('mark')">
                        <label for="mark">M</label>
                        <select class="custom-select" v-model="partData.mark" @change="modifyCue(`data.partsData`, localCue.data.partsData)" :disabled="!editable" style="width: 42px;">
                            <option v-for="(mark, index) in ['', 'M', 'Mh', 'Ml', 'D', 'R', '+', 'x']" :value="mark" :key="index">{{mark}}</option>
                        </select>
                    </md-input-container>
                </div>
            </div>
        </div>
        <div class="flex-row" v-else>
            <md-input-container class="field-time" v-if="isAvailable('time')">
                <label for="time">Time</label>
                <md-input :value="localCue.data.time" @blur="e => modifyCue('data.time', e)" :readonly="!editable"></md-input>
            </md-input-container>
            <md-input-container class="field-focus" v-if="isAvailable('focus')">
                <label for="focus">Focus</label>
                <md-input :value="localCue.data.focus" @blur="e => modifyCue('data.focus', e)" :readonly="!editable"></md-input>
            </md-input-container>
            <md-input-container class="field-color" v-if="isAvailable('color')">
                <label for="color">Color</label>
                <md-input :value="localCue.data.color" @blur="e => modifyCue('data.color', e)" :readonly="!editable"></md-input>
            </md-input-container>
            <md-input-container class="field-beam" v-if="isAvailable('beam')">
                <label for="beam">Beam</label>
                <md-input :value="localCue.data.beam" @blur="e => modifyCue('data.beam', e)" :readonly="!editable"></md-input>
            </md-input-container>
            <md-input-container class="field-mark" :class="{'md-has-value': localCue.data.mark}" v-if="isAvailable('mark')">
                <label for="mark">M</label>
                <select class="custom-select" :value="localCue.data.mark" @change="e => modifyCue('data.mark', e.target.value)" :disabled="!editable" style="width: 100%;">
                    <option v-for="(mark, index) in ['', 'M', 'Mh', 'Ml', 'D', 'R', '+', 'x']" :value="mark" :key="index">{{mark}}</option>
                </select>
            </md-input-container>
        </div>
        <div class="flex-row">
            <md-input-container class="field-duration" v-if="isAvailable('duration')">
                <label for="duration">Duration</label>
                <md-input :value="localCue.data.duration" @blur="e => modifyCue('data.duration', e)" :readonly="!editable"></md-input>
            </md-input-container>
            <md-input-container class="field-follow-hang-type" :class="{'md-has-value': localCue.data.followHangType}" v-if="isAvailable('followHang')">
                <label for="follow-hang-type">F/H</label>
                <select class="custom-select" :value="localCue.data.followHangType" @change="e => modifyCue('data.followHangType', e.target.value)" :disabled="!editable" style="width: 100%;">
                    <option v-for="(fh, index) in ['', 'F', 'H']" :value="fh" :key="index">{{fh}}</option>
                </select>
            </md-input-container>
            <md-input-container class="field-follow-hang" v-if="isAvailable('followHang')">
                <label for="follow-hang">Fw/Hg Time</label>
                <md-input :value="localCue.data.followHang" @blur="e => modifyCue('data.followHang', e)" :readonly="!editable"></md-input>
            </md-input-container>
            <md-input-container class="field-block" :class="{'md-has-value': localCue.data.block}" v-if="isAvailable('block')">
                <label for="block">Block</label>
                <select class="custom-select" :value="localCue.data.block" @change="e => modifyCue('data.block', e.target.value)" :disabled="!editable" style="width: 100%;">
                    <option v-for="(block, index) in ['', 'B', 'I', 'b']" :value="block" :key="index">{{block}}</option>
                </select>
            </md-input-container>
        </div>
        <div class="flex-row">
            <md-input-container class="field-assert" :class="{'md-has-value': localCue.data.assert}" v-if="isAvailable('assert')">
                <label for="assert">Assert</label>
                <select class="custom-select" :value="localCue.data.assert" @change="e => modifyCue('data.assert', e.target.value)" :disabled="!editable" style="width: 100%;">
                    <option v-for="(assert, index) in ['', 'A', 'a']" :value="assert" :key="index">{{assert}}</option>
                </select>
            </md-input-container>
            <md-input-container class="field-link" v-if="isAvailable('link')">
                <label for="link">Link</label>
                <md-input :value="localCue.data.link" @blur="e => modifyCue('data.link', e)" :readonly="!editable"></md-input>
            </md-input-container>
            <md-input-container class="field-loop" v-if="isAvailable('loop')">
                <label for="loop">Loop</label>
                <md-input :value="localCue.data.loop" @blur="e => modifyCue('data.loop', e)" :readonly="!editable"></md-input>
            </md-input-container>
            <md-input-container class="field-curve" v-if="isAvailable('curve')">
                <label for="curve">Curve</label>
                <md-input :value="localCue.data.curve" @blur="e => modifyCue('data.curve', e)" :readonly="!editable"></md-input>
            </md-input-container>
            <md-input-container class="field-external-links" v-if="isAvailable('externalLinks')">
                <label for="external-links">Ext Links</label>
                <md-input :value="localCue.data.externalLinks" @blur="e => modifyCue('data.externalLinks', e)" :readonly="!editable"></md-input>
            </md-input-container>
        </div>
        <div class="flex-row">
            <md-input-container class="field-notes" v-if="isAvailable('notes')">
                <label for="notes">Notes</label>
                <md-input :value="localCue.data.notes" @blur="e => modifyCue('data.notes', e)" :readonly="!editable"></md-input>
            </md-input-container>
        </div>
        <div class="flex-row">
            <md-input-container class="field-target" v-if="isAvailable('target')">
                <label for="target">Target</label>
                <md-input :value="localCue.data.target" @blur="e => modifyCue('data.target', e)" :readonly="!editable"></md-input>
            </md-input-container>
        </div>
        <div class="flex-row">
            <md-input-container class="field-preWait" v-if="isAvailable('preWait')">
                <label for="pre-wait">Pre Wait</label>
                <md-input :value="localCue.data.preWait" @blur="e => modifyCue('data.preWait', e)" :readonly="!editable"></md-input>
            </md-input-container>
            <md-input-container class="field-action" v-if="isAvailable('action')">
                <label for="action">Action</label>
                <md-input :value="localCue.data.action" @blur="e => modifyCue('data.action', e)" :readonly="!editable"></md-input>
            </md-input-container>
            <md-input-container class="field-postWait" v-if="isAvailable('postWait')">
                <label for="post-wait">Post Wait</label>
                <md-input :value="localCue.data.postWait" @blur="e => modifyCue('data.postWait', e)" :readonly="!editable"></md-input>
            </md-input-container>
        </div>
        <div class="flex-row">
            <md-input-container class="field-placement" v-if="isAvailable('placement')">
                <label for="placement">Placement</label>
                <md-input :value="localCue.data.placement" @blur="e => modifyCue('data.placement', e)" :readonly="!editable"></md-input>
            </md-input-container>
        </div>
        <div class="flex-row">
            <md-input-container class="field-purpose" v-if="isAvailable('purpose')">
                <label for="purpose">Purpose</label>
                <md-input :value="localCue.data.purpose" @blur="e => modifyCue('data.purpose', e)" :readonly="!editable"></md-input>
            </md-input-container>
        </div>
        <div class="flex-row">
            <md-input-container class="field-followMode" v-if="isAvailable('followMode')">
                <label for="follow-mode">Follow Mode</label>
                <md-input :value="localCue.data.followMode" @blur="e => modifyCue('data.followMode', e)" :readonly="!editable"></md-input>
            </md-input-container>
            <md-input-container class="field-routing" v-if="isAvailable('routing')">
                <label for="routing">Routing</label>
                <md-input :value="localCue.data.routing" @blur="e => modifyCue('data.routing', e)" :readonly="!editable"></md-input>
            </md-input-container>
        </div>
        <div class="flex-row">
            <md-input-container class="field-trigger" v-if="isAvailable('trigger')">
                <label for="trigger">Trigger</label>
                <md-input :value="localCue.data.trigger" @blur="e => modifyCue('data.trigger', e)" :readonly="!editable"></md-input>
            </md-input-container>
        </div>
        <div class="flex-row">
            <md-input-container class="field-propName" v-if="isAvailable('propName')">
                <label for="prop-name">Prop Name</label>
                <md-input :value="localCue.data.propName" @blur="e => modifyCue('data.propName', e)" :readonly="!editable"></md-input>
            </md-input-container>
            <md-input-container class="field-propQuantity" v-if="isAvailable('propQuantity')">
                <label for="prop-quantity">Prop Quantity</label>
                <md-input :value="localCue.data.propQuantity" @blur="e => modifyCue('data.propQuantity', e)" :readonly="!editable"></md-input>
            </md-input-container>
        </div>
        <div class="flex-row">
            <md-input-container class="field-preset" v-if="isAvailable('preset')">
                <label for="preset">Preset</label>
                <md-input :value="localCue.data.preset" @blur="e => modifyCue('data.preset', e)" :readonly="!editable"></md-input>
            </md-input-container>
        </div>
        <div class="flex-row">
            <md-input-container class="field-whoEnter ds" v-if="isAvailable('whoEnter')">
                <label for="who-enter">Who Enter</label>
                <md-input :value="localCue.data.whoEnter" @blur="e => modifyCue('data.whoEnter', e)" :readonly="!editable"></md-input>
            </md-input-container>
            <md-input-container class="field-whereEnter" v-if="isAvailable('whereEnter')">
                <label for="where-enter">Where Enter</label>
                <md-input :value="localCue.data.whereEnter" @blur="e => modifyCue('data.whereEnter', e)" :readonly="!editable"></md-input>
            </md-input-container>
        </div>
        <div class="flex-row">
            <md-input-container class="field-whoExit" v-if="isAvailable('whoExit')">
                <label for="who-exit">Who Exit</label>
                <md-input :value="localCue.data.whoExit" @blur="e => modifyCue('data.whoExit', e)" :readonly="!editable"></md-input>
            </md-input-container>
            <md-input-container class="field-whereExit" v-if="isAvailable('whereExit')">
                <label for="where-exit">Where Exit</label>
                <md-input :value="localCue.data.whereExit" @blur="e => modifyCue('data.whereExit', e)" :readonly="!editable"></md-input>
            </md-input-container>
        </div>
        <div class="flex-row">
            <md-input-container class="field-exitPage" v-if="isAvailable('exitPage')">
                <label for="exit-page">Exit Page</label>
                <md-input :value="localCue.data.exitPage" @blur="e => modifyCue('data.exitPage', e)" :readonly="!editable"></md-input>
            </md-input-container>
        </div>
        <div class="flex-row" v-for="(attr, index) in userDefined" :key="index">
            <!-- {{ localCue.data }} -->
            <md-input-container class="field-userDefined" v-if="attr.value === true">
                <label for="user-defined" v-if="attr.label">{{ attr.label }}</label>
                <label for="user-defined" v-else>User {{ index.replaceAll(/\D+/g, '') }}</label>
                <md-input :value="localCue.data[index]" @blur="e => modifyCue(`data.${index}`, e)" :readonly="!editable"></md-input>
            </md-input-container>
        </div>
        <div class="flex-row">
            <md-input-container class="field-propNotes" v-if="isAvailable('propNotes')">
                <label for="prop-notes">Prop Notes</label>
                <md-input :value="localCue.data.propNotes" @blur="e => modifyCue('data.propNotes', e)" :readonly="!editable"></md-input>
            </md-input-container>
            <md-input-container class="field-consumable" v-if="isAvailable('consumable')">
                <label for="consumable">Consumable</label>
                <select class="custom-select" :value="localCue.data.consumable" @change="e => modifyCue('data.consumable', e.target.value)" :disabled="!editable" style="width: 62px;">
                    <option v-for="(consumable, index) in ['N', 'Y']" :value="consumable" :key="index">{{consumable}}</option>
                </select>
            </md-input-container>
        </div>
        <div class="flex-row">
            <md-input-container class="field-rehearsal" v-if="isAvailable('rehearsal')">
                <label for="rehearsal">Rehearsal</label>
                <select class="custom-select" :value="localCue.data.rehearsal" @change="e => modifyCue('data.rehearsal', e.target.value)" :disabled="!editable" style="width: 42px;">
                    <option v-for="(rehearsal, index) in ['N', 'Y']" :value="rehearsal" :key="index">{{rehearsal}}</option>
                </select>
            </md-input-container>
            <md-input-container class="field-rehearsalSource" v-if="isAvailable('rehearsalSource')">
                <label for="rehearsal-source">Rehearsal Source</label>
                <md-input :value="localCue.data.rehearsalSource" @blur="e => modifyCue('data.rehearsalSource', e)" :readonly="!editable"></md-input>
            </md-input-container>
        </div>
        <div class="flex-row">
            <md-input-container class="field-actual" v-if="isAvailable('actual')">
                <label for="actual">Actual</label>
                <select class="custom-select" :value="localCue.data.actual" @change="e => modifyCue('data.actual', e.target.value)" :disabled="!editable" style="width: 42px;">
                    <option v-for="(actual, index) in ['N', 'Y']" :value="actual" :key="index">{{actual}}</option>
                </select>
            </md-input-container>
            <md-input-container class="field-actualSource" v-if="isAvailable('actualSource')">
                <label for="actual-source">Actual Source</label>
                <md-input :value="localCue.data.actualSource" @blur="e => modifyCue('data.actualSource', e)" :readonly="!editable"></md-input>
            </md-input-container>
        </div>
        
        <div class="flex-row" :class="{ 'work-note-row--noteslist-locked': notesListLinked }">
            <md-input-container class="field-label">
                <label for="work-note" class="cue-label">Work Note</label>
                <span class="work-note-control-wrap">
                    <md-button
                        class="md-icon-button md-dense btn-mark-workNote"
                        :class="{'workNote-marked': activeWorkNote}"
                        :disabled="notesListLinked || !editable"
                        @click="toggleWorkNote">
                        <md-icon v-show="!localCue.data.workNote || !activeWorkNote">check_box_outline_blank</md-icon>
                        <md-icon v-show="activeWorkNote">check_box</md-icon>
                    </md-button>
                    <md-tooltip md-direction="top" v-if="notesListLinked">Please check note on Notes List side</md-tooltip>
                    <md-tooltip md-direction="top" v-else-if="!localCue.data.workNote">Check or write text to add work note.</md-tooltip>
                    <md-tooltip md-direction="top" v-else>Uncheck to delete note without archiving.</md-tooltip>
                </span>
                <span class="work-note-control-wrap work-note-input-wrap">
                    <md-input 
                        style="padding-left:10px" 
                        :value="workingNote ? workingNote : ''" 
                        @blur="e => modifyCue('data.workNote', e)"
                        @keyup.enter.native="toggle"
                        :readonly="notesListLinked || !editable"
                        :disabled="notesListLinked"
                        ref="input_worknote"
                    ></md-input>
                    <md-tooltip v-if="notesListLinked" md-direction="top">Please check note on Notes List side</md-tooltip>
                </span>
                <!-- Archive stays available on a Notes-List-linked project. It is the
                     only way out for a note that was created in list view before that
                     entry point is closed: the field above is readonly and the
                     checkbox is disabled, so without this the user can SEE a note they
                     can never remove. Archiving clears the cue's asterisk
                     (cue-header.vue isActiveCue filters archived notes) and destroys
                     nothing. It cannot CREATE a note -- this control only renders when
                     `workingNote` is already truthy. -->
                <span class="work-note-control-wrap" v-if="editable && workingNote">
                    <md-button
                        class=" btn-archive-cue"
                        @click="toggleArchiveWorkNoteCue($event)">
                        <md-icon >move_to_inbox</md-icon>
                    </md-button>
                    <md-tooltip md-direction="top">Archive this work note.</md-tooltip>
                </span>
            </md-input-container>
        </div>
        <div class="footer">
            <!-- Also open on a linked project: archiving with no way to look at the
                 archive would be a one-way door. Inside, `unarchive` is suppressed
                 when linked (it would restore an ACTIVE note and re-create exactly
                 the state this is clearing); view and permanent delete remain. -->
            <div
                class="btn-view-archived-list"
                v-if="editable"
                @click="onWorkNoteModalOpen">
                <md-icon >move_to_inbox</md-icon>
                View Archived Work Notes
            </div>
            <md-button class="md-dense btn-close-button" @click="toggle">Close</md-button>
        </div>
    </form>
    <md-dialog class="collaborator-access-modal" ref="workNoteModal">
        <md-dialog-title class="modal-header">Archived Work Notes</md-dialog-title>
        <md-dialog-content style="display: flex; align-items: center;" >
            <md-layout v-if="editable && getArchivedWorkNotes.length" >
                <md-list-item class="worknote-item-cue" v-if="getArchivedWorkNotes.length === 1" style="border-bottom:0px" >
                    <div class="worknote-item-cue-info">
                        <div class="worknote-item-cue-info-body">
                            <div class="worknote-item-cue-info-desc" >{{getArchivedWorkNotes[0].note}}</div>
                            <div class="worknote-item-cue-info-date" style="padding-top:0px">
                                {{getEditedDateTime(getArchivedWorkNotes[0])}}
                                <md-button class="md-icon-button btn-archive-cue" v-if="editable && getArchivedWorkNotes[0].archived && !notesListLinked" @click="unArchivedWorkNoteCue(getArchivedWorkNotes[0], 0, $event)">
                                    <md-icon>unarchive</md-icon>
                                    <md-tooltip md-direction="left">Restore as the current note. Any current note on this cue is archived, not deleted.</md-tooltip>
                                </md-button>
                                <md-button class="md-icon-button btn-archive-cue" v-if="editable && getArchivedWorkNotes[0].archived" @click="removeArchivedNote(getArchivedWorkNotes[0], $event)">
                                    <md-icon >delete</md-icon>
                                    <md-tooltip md-direction="left">Permanently delete this note.</md-tooltip>
                                </md-button>
                            </div>
                        </div>
                    </div>
                </md-list-item>
                <template v-else>
                    <md-list-item class="worknote-item-cue" v-for="(workNote, index) in getArchivedWorkNotes" :key="workNote.editedAt">
                        <div class="worknote-item-cue-info">
                            <div class="worknote-item-cue-info-body">
                                <div class="worknote-item-cue-info-desc" >{{workNote.note}}</div>
                                <div class="worknote-item-cue-info-date" style="padding-top:0px">
                                    {{getEditedDateTime(workNote)}}
                                    <md-button class="md-icon-button btn-archive-cue" v-if="editable && workNote.archived && !notesListLinked" @click="unArchivedWorkNoteCue(workNote, index, $event)">
                                        <md-icon>unarchive</md-icon>
                                        <md-tooltip md-direction="left">Restore as the current note. Any current note on this cue is archived, not deleted.</md-tooltip>
                                    </md-button>
                                    <md-button class="md-icon-button btn-archive-cue" v-if="editable && workNote.archived" @click="removeArchivedNote(workNote, index, $event)">
                                        <md-icon >delete</md-icon>
                                        <md-tooltip md-direction="left">Permanently delete this note.</md-tooltip>
                                    </md-button>
                                </div>
                            </div>
                        </div>
                    </md-list-item>
                </template>
            </md-layout>
            
            <md-list-item class="worknote-item-cue" v-else style="border-bottom:0px">
                <div class="worknote-item-cue-info">
                    <div class="worknote-item-cue-info-body">
                        <span class="worknote-item-cue-info-desc" >There are no archived notes.</span>
                    </div>
                </div>
                
            </md-list-item>
        </md-dialog-content>
    </md-dialog>    
</md-card-content>
</template>

<script>
import { mapGetters } from 'vuex';
import debounce from 'lodash/debounce';
import * as cloneDeep from 'lodash/cloneDeep';
import NavBus from '@/buses/nav';
import { restoreNote, workNoteOf, writeOpenNote } from '@/lib/worknotes';
import { NOTESLIST_INTEGRATION_ENABLED } from '@/lib/URLs';
/**
 * Component For...
 */
const ProjectCuesCueBody = {
    name: 'projectCuesCueBody',
    props: [
        'cue',
        'locked',
        'editable',
        'color',
        'isFloatingCue',
        'focusInputWorkNote',
        'userDefined',
        'svgContentWidth',
        'svgTrueHeight'
    ],
    computed: {
        ...mapGetters([
            'layerByCue',
            'userProjectData',
            'selectedScale',
            'showMarginView',
            'selectedThumbnailView',
            'project'
        ]),
        notesListLinked() {
            // !! so this is a Boolean, not the production id string. It binds
            // straight to Boolean props (:disabled), which warn on a String.
            return !!(NOTESLIST_INTEGRATION_ENABLED
                && this.project
                && this.project.noteslist_link_status === 'linked'
                && this.project.noteslist_production_id);
        },
        layer() {
            return this.layerByCue(this.cue);
        },
        availableAttrs() {
            return Object.keys(this.layer.attributes || {}).filter((attr) => {
                if (this.isRightClicked) {
                    return attr === 'label';
                }
                return this.layer.attributes[attr];
            });
        },
        activeWorkNote() {
            if (typeof workNoteOf(this.localCue) === 'string') {
                return workNoteOf(this.localCue) === '' ? false : workNoteOf(this.localCue);
            }
            
            const currentWorkNote = workNoteOf(this.localCue).filter(note => !!note.note && !note.archived);
            return currentWorkNote.length > 0 ? currentWorkNote[0].note : '';
        },
        getArchivedWorkNotes() {
            if (typeof workNoteOf(this.localCue) === 'string') {
                return [];
            }
            const archivedWorkNotes = workNoteOf(this.localCue).filter(note => !!note.note && note.archived).sort((a, b) => b.editedAt - a.editedAt);
            return archivedWorkNotes;
        },
        workingNote() {
            return this.getWorkNote(workNoteOf(this.localCue));
        }
    },
    data: function() {
        return {
            editing: false,
            oldVal: this.$props.cue.description,
            localCue: this.$props.cue,
            updateCueTimerId: null,
            modifyCueTimerId: null,
            workNoteModal: true,
            handler: 0,
            isRightClicked: false
        };
    },
    mounted() {
        NavBus.$on('cue-opened-with-right-click', () => {
            setTimeout(() => this.$refs.input_worknote.$el.focus(), 10);
            this.isRightClicked = true;
        });
        document.addEventListener('click', this.handleClickOutside);
    },
    beforeDestroy() {
        document.removeEventListener('click', this.handleClickOutside);
    },
    watch: {
        cue: {
            handler: function() {
                this.localCue = this.cue;
            },
            deep: true
        }
        // No save when the work note becomes '' here: every control that clears it saves
        // the cue itself. The watcher that did also fired for a clear made ELSEWHERE (a
        // collaborator, the 20 Oct repair), so every viewer saved the cue again and the
        // show was stamped edited ("opening = edited", Josh, 20 Oct 2026).
    },
    methods: {
        handleClickOutside(event) {
            if (!this.$el.contains(event.target)) {
                this.isRightClicked = false;
            }
        },
        edit() {
            this.editing = true;
        },
        done() {
            this.editing = false;
            this.oldVal = this.cue.description;
            this.$emit('cueUpdated', this.cue);
        },
        cancel() {
            this.editing = false;
            this.cue.description = this.oldVal;
        },
        keyPress(e) {
            if (e.keyCode === 13) {
                e.target.blur();
            }
        },
        destroy() {
            this.$emit('destroy');
        },
        makeCueFixed() {
            this.$emit('toggle');
            this.$store.dispatch('removeCueFloating', {
                id: this.cue.id
            });
        },
        isAvailable(target) {
            return this.availableAttrs.includes(target);
        },
        onWorkNoteModalOpen() {
            this.workNoteModal = true;
            this.$refs.workNoteModal.open();
        },
        onWorkNoteModalClose() {
            this.workNoteModal = false;
            this.$refs.workNoteModal.close();
        },
        getEditedDateTime(note) {
            const nowSeconds = Date.now();
            let date = new Date(nowSeconds);
            if (note.editedAt) {
                date = typeof note.editedAt === 'number' ? new Date(note.editedAt) : new Date(note.editedAt.seconds * 1000);
            }
            
            // Hours part from the timestamp
            let hours = date.getHours();
            const ampm = hours >= 12 ? 'PM' : 'AM';
            hours %= 12;
            hours = hours > 0 ? hours : 12; // the hour '0' should be '12'
            // Minutes part from the timestamp
            const minutes = '0' + date.getMinutes();
            // Seconds part from the timestamp
            const seconds = '0' + date.getSeconds();
            const year = date.getFullYear();
            const month = '0' + (date.getMonth() + 1);
            const day = '0' + date.getDate();
            // Will display time in 10:30:23 format
            const formattedTime = month.substr(-2) + '/' + day.substr(-2) + '/' + year + ' ' + hours + ':' + minutes.substr(-2) + ':' + seconds.substr(-2) + ' ' + ampm;
            return formattedTime;
        },
        partsChanged() {
            // Seed part 1 from the cue's current values the first time parts are added — including
            // when partsData is still the empty array it's initialized to at cue creation — so a time
            // entered before adding parts becomes part 1's time and the remaining parts start blank.
            if (!this.localCue.data.partsData || !this.localCue.data.partsData.length) {
                this.localCue.data.partsData = [{
                    id: 1,
                    label: '',
                    time: this.localCue.data.time,
                    focus: this.localCue.data.focus,
                    color: this.localCue.data.color,
                    beam: this.localCue.data.beam,
                    mark: this.localCue.data.mark
                }];
            }
            if (this.localCue.data.parts) {
                const cnt = (this.localCue.data.partsData && this.localCue.data.partsData.length) || 0;
                if (cnt > this.localCue.data.parts) {
                    this.localCue.data.partsData.splice(this.localCue.data.parts);
                } else if (cnt < this.localCue.data.parts) {
                    this.localCue.data.partsData = this.localCue.data.partsData.concat(new Array(this.localCue.data.parts - cnt).fill({
                        label: '',
                        time: '',
                        focus: '',
                        color: '',
                        beam: '',
                        mark: ''
                    }).map((partData, index) => ({...partData, id: index + cnt + 1})));
                }
            } else {
                if (this.localCue.data.partsData.length) {
                    this.localCue.data.time = this.localCue.data.partsData['0'].time;
                    this.localCue.data.focus = this.localCue.data.partsData['0'].focus;
                    this.localCue.data.color = this.localCue.data.partsData['0'].color;
                    this.localCue.data.beam = this.localCue.data.partsData['0'].beam;
                    this.localCue.data.mark = this.localCue.data.partsData['0'].mark;
                }
                this.localCue.data.partsData = null;
            }
            this.updateCue();
        },
        getPartIndex(target) {
            return this.localCue.data.partsData.findIndex(partData => partData.id === target.id);
        },
        updateCue() {
            const updatingCue = {...this.localCue};
            this.updateCueTimerId = setTimeout(() => {
                this.$emit('cueUpdated', updatingCue);
            }, 10);
            this.$store.dispatch('updateCue', {...this.localCue});
        },
        modifyCue(key, value) {
            if (key === 'data.workNote' && this.notesListLinked) {
                return;
            }
            let cueValue = value;
            if (key === 'data.workNote') {
                // Unchanged (or empty with no open note) saves nothing (lib/worknotes.js writeOpenNote, 29 Oct 2026).
                cueValue = writeOpenNote(workNoteOf(this.localCue), value, Date.now());
                if (cueValue === null) return;
            } else if (key !== 'data.partsData' && window.objectPath.get(this.localCue, key) === value) {
                return;
            }
            // Keep localCue in sync immediately (the store modifyCue action only writes to
            // Firestore and localCue otherwise updates on the async echo). Without this, an action
            // reading localCue right after an edit — e.g. partsChanged seeding part 1 from
            // data.time — sees the stale value instead of what the user just entered.
            if (key !== 'data.workNote') {
                window.objectPath.set(this.localCue, key, cueValue);
            }
            this.$store.dispatch('modifyCue', {
                id: this.cue.id,
                data: {
                    [key]: cueValue
                }
            });
        },
        getWorkNote(note) {
            if (typeof note === 'string') {
                return note === '' ? false : note;
            }
            const activeNote = note.filter(n => !n.archived);
            return activeNote.length ? activeNote[0].note : false;
        },
        emitUpdateCue() {
            this.$store.dispatch('updateCue', this.localCue);
        },
        toggleWorkNote() {
            if (!this.editable || this.notesListLinked) return;
            
            if (typeof workNoteOf(this.localCue) === 'string') {
                this.localCue.data.workNote = workNoteOf(this.localCue) ? '' : [{note: ' ', archived: false, editedAt: Date.now()}];
            } else if (this.activeWorkNote) {
                this.localCue.data.workNote = '';
            } else {
                const archivedNote = workNoteOf(this.localCue).filter(note => note.archived);
                let newActiveNote = '';
                let originWorkNotes = workNoteOf(this.localCue);
                if (archivedNote.length > 0) {
                    newActiveNote = {note: ' ', archived: false, editedAt: Date.now()};
                    originWorkNotes.push(newActiveNote);
                } else {
                    originWorkNotes = '';
                }
                this.localCue.data.workNote = originWorkNotes;
            }
            this.updateCue();
        },
        unArchivedWorkNoteCue(note, index, e) {
            e.preventDefault();
            e.stopPropagation();
            if (!this.editable) return;

            // The cue's open note is archived, not deleted (Josh, 11 Oct 2026). Match the
            // restored note by editedAt: the old index went stale once the open note was spliced out.
            const newWorkNotes = restoreNote(workNoteOf(this.localCue), note.editedAt)
                .map(item => (item.editedAt === note.editedAt && !item.archived ? { ...item, editedAt: Date.now() } : item))
                .sort((a, b) => b.editedAt - a.editedAt);
            
            const key = 'data.workNote';
            this.$store.dispatch('modifyCue', {
                id: this.cue.id,
                data: {
                    [key]: newWorkNotes
                }
            });
        },
        removeArchivedNote(item, e) {
            e.preventDefault();
            e.stopPropagation();
            if (!this.editable) return;

            const tempWorkNote = workNoteOf(this.localCue);
            const isSameEditedAt = (element) => {
                return element.editedAt === item.editedAt;
            };
            const activeIndex = tempWorkNote.findIndex(isSameEditedAt);
            if (activeIndex > -1) tempWorkNote.splice(activeIndex, 1);
            const key = 'data.workNote';
            this.$store.dispatch('modifyCue', {
                id: this.cue.id,
                data: {
                    [key]: tempWorkNote
                }
            });
        },
        toggleArchiveWorkNoteCue(e) {
            e.preventDefault();
            e.stopPropagation();
            // notesListLinked deliberately NOT checked: archiving is the escape
            // hatch for an already-stranded note. Creating and editing stay blocked
            // above (toggleWorkNote, and the readonly input).
            if (!this.editable) return;
            
            const tempCue = cloneDeep(this.localCue);
            let newWorkNotes = [];
            if (typeof workNoteOf(tempCue) === 'string') {
                newWorkNotes = [{
                    note: workNoteOf(tempCue),
                    archived: true,
                    editedAt: Date.now()
                }];
            } else {
                newWorkNotes = workNoteOf(tempCue).map((item) => {
                    if (item.archived === false) {
                        item.archived = true;
                        item.editedAt = Date.now();
                    }
                    return item;
                });
            }
            
            const key = 'data.workNote';
            this.$store.dispatch('modifyCue', {
                id: this.cue.id,
                data: {
                    [key]: newWorkNotes
                }
            });
            this.sortWorkNotes();
        },
        toggle() {
            this.$emit('toggle');
        },
        style() {
            if (this.showMarginView && this.selectedThumbnailView !== 'true') {
                const leftEdgeElements = document.querySelectorAll('.leftEdge');

                let maxWidth = 0;
                let maxElement = null;

                // Loop through the elements and find the one with the highest width
                for (const element of leftEdgeElements) {
                    const rect = element.getBoundingClientRect();
                    const width = rect.width;
                    const elementWidth = width;
                    if (elementWidth > maxWidth) {
                        maxWidth = elementWidth;
                        maxElement = element;
                    }
                }
                const rightEdgeElements = document.querySelectorAll('.rightEdge');

                let maxRightWidth = 0;
                let maxRightElement = null;

                // Loop through the elements and find the one with the highest width
                for (const element of rightEdgeElements) {
                    const rect = element.getBoundingClientRect();
                    const width = rect.width;
                    const elementWidth = width;
                    if (elementWidth > maxRightWidth) {
                        maxRightWidth = elementWidth;
                        maxRightElement = element;
                    }
                }
                const fullWidth = Number.parseInt(((Math.max(maxWidth, maxRightWidth)) + this.svgContentWidth + (Math.max(maxWidth, maxRightWidth))), 10);
                if ((fullWidth > window.innerWidth) && (maxElement || maxRightElement)) {
                    const divElement = document.querySelector('.page-viewer');
                    divElement.style.width = (Number.parseInt(((Math.max(maxWidth, maxRightWidth)) + this.svgContentWidth + (Math.max(maxWidth, maxRightWidth))), 10) + (50)) + 'px';
                    divElement.style.margin = '0 auto';
                } else if (document.querySelector('.page-viewer')) {
                    document.querySelector('.page-viewer').style.width = 'auto';
                    document.querySelector('.page-viewer').style.margin = '0';
                }
            } else if (document.querySelector('.page-viewer')) {
                document.querySelector('.page-viewer').style.width = 'auto';
                document.querySelector('.page-viewer').style.margin = '0';
            }
            
            return `border-top: 1px solid ${this.color}; width: ${(this.svgContentWidth - 5) / this.selectedScale}px`;
        },
        sortWorkNotes() {
            if (workNoteOf(this.localCue) !== '') {
                this.localCue.data.workNote = workNoteOf(this.localCue).sort((a, b) => a.editedAt - b.editedAt);
            }
        }
    },
    created: function() {
        this.debouncedUpdateCue = debounce(this.emitUpdateCue, 10);
    }
};

export default ProjectCuesCueBody;
</script>

<style lang="scss">
.md-card-content {
    height: auto;
}
.custom-select {
    border: none !important;
    appearance: none;
    -webkit-appearance: none; 
    -moz-appearance: none;
    background: none;
    cursor: pointer;
    text-align: center;
    text-align-last: center;
}
.custom-select:focus,
.custom-select:focus-visible {
    border: none !important;
    outline: none !important;
    box-shadow: none !important;
}
.md-menu-content.md-direction-bottom-right.md-active {
      min-width: 240px !important;
      top: 88px !important;
      z-index: 998 !important;
      transform: translateY(-99px);
      margin-left: 10px;
}
.md-menu-content.md-direction-bottom-left.md-active {
      min-width: 200px !important;
}
.ql-cue-body {
    box-sizing: border-box;
    padding: 12px 12px 0 !important;
    width: 400px !important;
    cursor: no-drop;

    margin: 4px, 4px;
    height: auto !important;
    max-height: 200px !important;
    overflow-x: hidden;
    overflow-y: auto;
    text-align: justify;
    .md-button {
        float: right;
    }

    .btn-close-button {
        margin: 2px 0 6px;
        padding: 0 8px;
        min-width: 0;
        color: #5ecfdf;
        font-weight: 700;
    }

    .cue-description {
        white-space: pre-line;
    }

    .flex-row {
        display: flex;
        align-items: center;
        & > .md-input-container {
            margin-right: 4px;
            &:last-child {
                margin-right: 0;
            }
        }
    }
    .flex-wrap {
        flex-wrap: wrap;
    }
    .flex-column {
        flex-direction: column;
        .flex-row {
            width: 100%;
        }
    }

    .md-select {
        min-width: 20px;
        text-align: center;
        .md-select-value {
            padding-right: 0;
        }
        &:after {
            display: none;
        }
    }

    .md-input-container {
        border: solid 1px #bbb;
        border-radius: 5px;
        padding: 4px 8px;
        min-height: 16px;
        margin: 4px 0;
        label {
            color: #aaa;
            top: 50%;
            transform: translateY(-50%);
            left: 1em;
            line-height: 1;
            font-size: 14px;
            white-space: nowrap;
        }
        .md-input {
            font-size: 12px;
        }
        .md-select {
            height: 16px;
            .md-menu {
                height: 16px;
            }
            .md-select-value {
                font-size: 12px;
                height: 16px;
                line-height: 16px;
            }
        }
        &.md-has-value, &.md-input-focused {
            label {
                transform: translateY(-20px);
                padding: 2px 0;
                background: #fff;
                color: #00838f;
                font-size: 11px;
                &:after {
                    content: '';
                    display: block;
                    position: absolute;
                    width: 120%;
                    height: 100%;
                    left: -10%;
                    top: 0;
                    background: #fff;
                    z-index: -1;
                }
                &.cue-label {
                    left: 1rem !important;
                    padding:0px;
                }
            }
            textarea.md-input {
                min-height: 110px;
                max-height: 110px;
            }
        }
        input, textarea {
            height: 16px;
            line-height: 16px;
        }
        &:after {
            display: none;
        }
        &:not(.field-description):not(.field-notes):not(.field-label):not(.field-part-label) {
            label {
                left: 50%;
                transform: translate(-50%, -50%);
            }
            .md-input {
                text-align: center;
            }
            &.md-has-value, &.md-input-focused {
                label {
                    transform: translate(-50%, -20px);
                }
                
            }
        }
    }

    .cue-label {
        left: 2rem !important;
        
    }

    .field-parts {
        width: 70px;
        margin-left: 8px;
    }
    .field-parts-data {
        width: 100%;
        label {
            font-size: 12px;
        }
    }
    .field-part {
        flex: 0 0 40px;
        .md-input {
            text-align: center;
        }
    }
    .field-mark {
        width: 40px;
    }
    .field-duration {
        flex: 1 0 40%;
    }
    .field-follow-hang {
        flex: 1 0 30%;
    }
    .field-link {
        flex: 1 0 24%;
    }
    .field-external-links {
        flex: 1 0 22%;
    }

    .field-preWait, .field-postWait {
        flex: 1 0 27%;
        label {
            white-space: nowrap;
        }
    }

    .field-followMode {
        flex: 1 0 30%;
        label {
            white-space: nowrap;
        }
    }

    .field-block, .field-assert, .field-external-links {
        label {
            font-size: 12px;
        }
    }

    .field-time, .field-focus, .field-color, .field-beam {
        .md-input {
            font-size: 12px;
        }
    }

    .field-label, .field-description, .field-notes {
        .md-input {
            font-size: 12px;
        }
    }

    .field-consumable, .field-rehearsal, .field-actual {
        width: 80px;
        label {
            font-size: 12px;
        }
    }

    .btn-mark-workNote {
        margin: 0;
        width: 16px !important;
        height: 16px !important;
        padding: 0 !important;
        min-width: 0 !important;
        min-height: 0 !important;
        line-height: 16px !important;
        i {
            margin: auto !important;
            color: rgba(0, 0, 0, 0.54) !important;
            width: 16px;
            min-width: 16px;
            height: 16px;
            min-height: 16px;
            font-size: 16px;
        }
        &.workNote-marked {
            i {
                color: #5ecfdf !important;
            }
        }
        
    }
}

.md-theme-show-mode {
    .ql-cue-body {
        .md-input-container {
            &.md-has-value, &.md-input-focused {
                label {
                    background: #424242;
                    color: #5ecfdf !important;
                    &:after {
                        background: #424242;
                    }
                }
            }
        }
    }
}

.btn-archive-cue {
    width: 20px;
    height: 15px;
    min-width: 20px;
    min-height: 15px;
    padding: 0px;
    margin: 0 auto;

    .md-icon {
        width: 16px;
        min-width: 15px;
        height: 14px;
        min-height: 16px;
        font-size: 18px;
        position: relative;
        bottom: 9px;
        margin: 0 auto;
    }
}

.btn-view-archived-list {
    cursor: pointer;

    &--disabled {
        opacity: 0.55;
        cursor: not-allowed;
        pointer-events: auto;
    }
}

// The locked look applies to what is ACTUALLY locked on a linked project: the
// create/clear checkbox and the text input. NOT the archive button -- archive is
// deliberately available here (see toggleArchiveWorkNoteCue), and dimming it to
// 0.6 with cursor: not-allowed made a working control look dead. Nobody clicks a
// button that says it cannot be clicked, so the fix shipped and did nothing.
.work-note-row--noteslist-locked {
    .btn-mark-workNote,
    input {
        opacity: 0.6;
        cursor: not-allowed;
    }
}

.work-note-control-wrap {
    position: relative;
    display: inline-flex;
    align-items: center;
}

.work-note-input-wrap {
    flex: 1;
    min-width: 0;
}

.modal-header {
    font-size: 20px !important;
    font-weight: 600 !important;
    padding: 10px !important;
    background: #8f949e !important;
    color: black !important;
}

.worknote-item-cue {
    border-bottom: 1px solid #ddd;
    box-sizing: border-box;
    list-style: none;
    .worknote-item-cue-info {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        line-height: 1.3;
        padding: 8px 0;
        width: auto;
        max-width: 100%;
        .worknote-item-cue-info-title {
            font-weight: 600;
            margin-bottom: 4px;
            display: block;
        }
        .worknote-item-cue-info-body {
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;
            line-height: 1.3;
            padding: 0px 0;
            justify-content: space-between;
            max-width: 100%;
            width: 550px;
            .worknote-item-cue-info-date {
                padding-top: 0px;
                align-self: flex-end;
                margin-left: auto;
            }
        }
        .worknote-item-cue-info-desc {
            text-overflow: ellipsis;
            overflow: hidden;
            margin-right:15px;
        }
        .btn-archive-cue {
            width: 23px;
            height: 26px;
            min-width: 20px;
            min-height: 20px;
            padding: 0px;
            top: -6px;
        }
    }
}

.footer {
    display:flex;
    align-items: center;
    justify-content: space-between;
}

.collaborator-access-modal {
    .md-dialog {
        overflow: auto !important;
    }
    
}
</style>


// WEBPACK FOOTER //
// cue-body.vue?a5ea69d0